<template>
  <div class="htfbwntj">
    <!-- <sec-title Text="为你推荐" class="text_center" /> -->
	<div class="title">
		为你推荐
		<div class="line"></div>
	</div>
	<div class="choosebar flex flex_start">
		<div :class="['chooseitem',index == 1?'choose-active':'']" v-for="(item,index) in 8">
			热门合同
		</div>
		<div class="chooseitem" >
			更多>
		</div>
	</div>
    <!-- tab栏目 -->
    <!-- <div class="tagtitle flex_start">
      <div
        class="tagitem"
        v-for="(item, index) in taglist"
        :key="index"
        :class="{ itemac: index == tagact }"
        @click="tagcli(index)"
      >
        {{ item }}
      </div>
      <div class="tagitem">更多></div>
    </div> -->
    <div class="htlist between wrap">
      <htcarditem
        class="htitem"
        v-for="(item, index) in hdlist"
        :key="index"
        :hditem="item"
      />
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import htcarditem from "../components/htcarditem.vue";

export default {
  components: {
    secTitle,
    htcarditem,
  },
  data: () => ({
    tagact: 0,
    taglist: [
      "热门合同",
      "最新合同",
      "租房全保障",
      "专业HR必备",
      "离婚保卫战",
      "创业宝典",
    ],
    hdlist: [],
  }),
  beforeMount() {
    this.gettjhd();
  },
  methods: {
    tagcli(index) {
      this.tagact = index;
    },
    gettjhd() {
      let data = {
        limit: 8,
        order: "hot",
        page: 1,
      };
      this.$http.jpcol.getcontractlist(data).then((res) => {
        this.hdlist = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.htfbwntj {
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 50px;
  .title{
	  position: relative;
	  width: 200px;
	  height: 36px;
	  font-size: 38px;
	  font-weight: 500;
	  color: #333333;
	  line-height: 30px;
	  text-align: center;
	  margin: 0 auto;
	  .line{
		  position: absolute;
		  top: 45px;
		  margin-left: -35px;
		  left: 50%;
		  width: 70px;
		  height: 4px;
		  background: #0465EA;
	  }
  }
  .choosebar{
	  margin-top: 50px;
	  .chooseitem{
		  width: 130px;
		  height: 40px;
		  background-color: #ffffff;
		  text-align: center;
		  line-height: 40px;
		  margin-right: 15px;
	  }
	  .choose-active{
		 background: #0465EA; 
		 color: #ffffff;
	  }
  }
  
  .tagtitle {
    margin-top: 30px;
    .tagitem {
      cursor: pointer;
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin-right: 16px;
      background: #fff;
      color: #323232;
      &.itemac {
        color: #ffffff;
        background: #0465ea;
      }
    }
  }
  .htlist {
    .htitem {
      width: 282px;
      height: 417px;
      margin-top: 30px;
    }
  }
}
</style>